import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const paywalls = {
  overview: {
    total_transactions: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/overview/total_transactions",
        params,
      ),
    total_revenue: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/overview/total_revenue",
        params,
      ),
    sales_breakdown: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/overview/sales_breakdown",
        params,
      ),
    revenue_breakdown: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/overview/revenue_breakdown",
        params,
      ),
    revenue_growth: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/overview/revenue_growth",
        params,
      ),
    highest_grossing_paywalls: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/overview/highest_grossing_paywalls",
        params,
      ),
  },
  one_time: {
    total_transactions: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/one_time/total_transactions",
        params,
      ),
    total_revenue: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/one_time/total_revenue",
        params,
      ),
    revenue_growth: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/one_time/revenue_growth",
        params,
      ),
    average_order_value: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/one_time/average_order_value",
        params,
      ),
    repurchases: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/one_time/repurchases",
        params,
      ),
  },
  installments: {
    installment_revenue: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/installments/installment_revenue",
        params,
      ),
    active_installments: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/installments/active_installments",
        params,
      ),
    installments_revenue_growth: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/installments/installments_revenue_growth",
        params,
      ),
  },
  subscriptions: {
    monthly_recurring_revenue: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/subscriptions/monthly_recurring_revenue",
        params,
      ),
    annual_recurring_revenue: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/subscriptions/annual_recurring_revenue",
        params,
      ),
    active_subscribers_count: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/subscriptions/active_subscribers_count",
        params,
      ),
    net_monthly_recurring_revenue_growth: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/subscriptions/net_monthly_recurring_revenue_growth",
        params,
      ),
    new_subscribers_count: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/subscriptions/new_subscribers_count",
        params,
      ),
    active_trials_count: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/subscriptions/active_trials_count",
        params,
      ),
    trial_conversion: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/subscriptions/trial_conversion",
        params,
      ),
    net_subscribers_growth: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/subscriptions/net_subscribers_growth",
        params,
      ),
    average_monthly_revenue: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/subscriptions/average_monthly_revenue",
        params,
      ),
    churn_rate: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/subscriptions/churn_rate",
        params,
      ),
    monthly_recurring_revenue_growth: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/subscriptions/monthly_recurring_revenue_growth",
        params,
      ),
    active_subscriptions_growth: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/subscriptions/active_subscriptions_growth",
        params,
      ),
  },
  conversions: {
    rate_histogram: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/conversions/rate_histogram",
        params,
      ),
    number_of_page_views: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/conversions/number_of_page_views",
        params,
      ),
    number_of_conversions: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/conversions/number_of_conversions",
        params,
      ),
    conversion_rate: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/conversions/conversion_rate",
        params,
      ),
    number_of_first_time_visitors: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/conversions/number_of_first_time_visitors",
        params,
      ),
    number_of_repeat_visitors: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/conversions/number_of_repeat_visitors",
        params,
      ),
    median_time_to_convert: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/conversions/median_time_to_convert",
        params,
      ),
    devices: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/conversions/devices",
        params,
      ),
    browsers: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/conversions/browsers",
        params,
      ),
    bounce_rate: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/conversions/bounce_rate",
        params,
      ),
    referral_uris: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/conversions/referral_uris",
        params,
      ),
    views_per_country: (params: AnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/paywalls/conversions/views_per_country",
        params,
      ),
  },
};
